import * as actionTypes from 'modules/audits/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = {};

const fetchUsersSelectSuccess = (state, { payload }) => {
  const usersSelect = state[payload.selectId]?.userIds ?? [];

  return {
    ...state,
    [payload.selectId]: {
      userIds: usersSelect.concat(payload.userIds),
      links: payload.links,
      page: payload.page,
    },
  };
};

const clearUsersSelect = (state, { payload }) => {
  const { [payload?.selectId]: usersSelectToRemove, ...newState } = state;
  return newState;
};

export default createReducer(initialState, {
  [actionTypes.FETCH_USERS_SELECT_SUCCESS]: fetchUsersSelectSuccess,
  [actionTypes.CLEAR_USERS_SELECT]: clearUsersSelect,
});
